document.addEventListener('DOMContentLoaded', () => {
    // Toggle menu items on mobile only
    const menuToggles = document.querySelectorAll('.footer-menu__toggle');

    menuToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();

            // Only run on mobile screens
            if (window.innerWidth >= 768) {
                return;
            }

            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const nav = this.nextElementSibling;

            if (isExpanded) {
                this.setAttribute('aria-expanded', 'false');
                if (nav) {
                    nav.style.maxHeight = '0';
                    nav.style.opacity = '0';
                }
            } else {
                this.setAttribute('aria-expanded', 'true');
                if (nav) {
                    nav.style.maxHeight = nav.scrollHeight + 'px';
                    nav.style.opacity = '1';
                }
            }
        });
    });
});
